
export default function Introduction() {
  return (
    <section id="introduction" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1E3A5F] mb-6">
            Notre Histoire
          </h2>
          <div className="w-24 h-1 bg-[#A83232] mx-auto mb-8"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/049a90d5e15be63d51942825edca5721.jpg"
              alt="Atelier Reda & Naoual"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover"
            />
          </div>

          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              <strong className="text-[#1E3A5F]">Sté Reda et Naoual</strong> est fière de vous présenter son catalogue professionnel, résultat de plus de <strong className="text-[#A83232]">20 ans d'expérience</strong>, de travail acharné et de passion pour l'excellence.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Depuis sa création, notre entreprise s'est engagée à fournir des <strong className="text-[#1E3A5F]">produits et services de haute qualité</strong>, répondant aux besoins spécifiques de nos clients et dépassant leurs attentes.
            </p>
            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-[#A83232] mb-2">20+</div>
                <div className="text-sm text-gray-600">Années d'expérience</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#A83232] mb-2">500+</div>
                <div className="text-sm text-gray-600">Projets réalisés</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#A83232] mb-2">100%</div>
                <div className="text-sm text-gray-600">Satisfaction client</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
